import CollectionEditModalComponent from "./CollectionEditModalComponent";

export default CollectionEditModalComponent;